export const SUBSCRIBE_EMAIL_URL = 'https://dev-api.freeflix.in/subscribe-network';
export const CONTACT_DETAILS_URL = 'https://dev-api.freeflix.in/feedback';
